import { RouteConfig } from 'vue-router';

import Reports from '@/pages/reports/Reports.vue';
import { refreshToken } from '@/router/guards/refreshToken';

export const reportsRoute: RouteConfig = {
  beforeEnter: refreshToken,
  meta: {
    title: 'Daily Report List',
  },
  path: '/reports',
  component: Reports,
};
